<template>
  <van-dialog
    v-model="dialogVisible"
    :show-confirm-button="false"
    width="325px"
    :close-on-click-overlay="true"
    class="guide-dialog"
    style="height: 75% !important; overflow: auto"
  >
    <div class="guide-container">
      <div class="guide-box">
        <div class="guide-title">
          <h1>充值引导</h1>
          <span class="under-style"></span>
        </div>
        <!-- <img @click="dialogVisible = false" class="close" src="@/assets/images/rule-icon.png" alt=""> -->
        <div class="guide-item">
          <h1>第一步：</h1>
          <span>下载游戏(同一弹窗内均为同一款游戏，仅折扣存在差异)</span>
          <img src="http://apk.wmsy666.com/img/app/jiaocheng/wm-step1.png" alt="" />
        </div>
        <div class="guide-item">
          <h1>第二步：</h1>
          <span>APP内充值代金券（折扣充值）</span>
          <img src="http://apk.wmsy666.com/img/app/jiaocheng/wm-step2.png" alt="" />
        </div>
        <div class="guide-item">
          <h1>第三步：</h1>
          <span>游戏内消费，使用代金券支付（代金券=人名币，无需再额外付钱）</span>
          <img src="http://apk.wmsy666.com/img/app/jiaocheng/wm-step3.png" alt="" />
        </div>

        <div class="confirm" @click="dialogVisible = false">我知道了</div>
      </div>
    </div>
  </van-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    noticeInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },
  },
  mounted() {},
  methods: {
    confirm() {
      this.dialogVisible = false;
      if (this.noticeInfo.jump == 1) {
        this.$router.push({ path: "/gameCircle" });
      }
    },
  },
};
</script>

<style lang="scss">
.guide-dialog {
  border-radius: 48px;
}
.guide-dialog,
.van-dialog__content {
    // overflow: visible; /* 允许内容超出 */
  height: 100%;
  // overflow: hidden;
}
.guide-container {
  // width: 650px;
  height: 100%;
  // background: linear-gradient(180deg, #ffc6ac 0%, #ffffff 30%);
  background-image: url(~@/assets/images/mask.png);
  background-size: 100% 32%;
  background-repeat: no-repeat;
  padding: 50px;
  background-attachment: fixed; /* 确保背景不会滚动 */
  overflow-y: scroll;

  .guide-box {
    height: 100%;
    overflow: auto;
  }

  .guide-title {
    text-align: center;
    margin-bottom: 50px;
    h1 {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 40px;
      color: #895c42;
    }
    span {
      display: block;
      width: 200px;
      height: 18px;
      margin-left: 190px;
      margin-top: -8px;
      background: linear-gradient(
        270deg,
        rgba(255, 230, 219, 0.25) 0%,
        rgba(255, 122, 62, 0.36) 100%
      );
    }
  }

  .guide-item {
    margin-bottom: 48px;
    h1 {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 30px;
      color: #22242a;
      line-height: 42px;
    }
    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 26px;
      color: #333;
      line-height: 42px;
    }
    img {
      width: 100%;
      margin-top: 18px;
    }
  }

  .confirm {
    margin: 0 auto;
    width: 400px;
    height: 80px;
    background: #ff8441;
    color: #fff;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 32px;
    border-radius: 40px;
    line-height: 80px;
    margin-top: 74px;
    text-align: center;
  }
}
// .van-dialog {
//   background: transparent;
// }
</style>


// WEBPACK FOOTER //
// src/components/RechargeGuideDialog.vue